const LanguageCodes = {
  English: 'en',
  Italian: 'it',
  Spanish: 'es',
  French: 'fr',
  Greek: 'el',
}

export default LanguageCodes
